/* TEKTRON: gac mau app — chi de mau Judge.me / sticky bar khi app con MAU GOC luc dong bo; doi BAT KY mau nao trong app la mau app thang. Tu sinh, dung sua tay. */
(function(){
  var GOC={jdgm:"",jdgm_sao:"",jdgm_nut:"",sticky:"",sticky_nut:""}, h=document.documentElement;
  function hex(c){var m=/rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(c||"");if(!m)return (c||"").trim().toLowerCase();
    return "#"+[m[1],m[2],m[3]].map(function(x){return ("0"+(+x).toString(16)).slice(-2)}).join("")}
  function khop(goc,hien){return !goc||hex(hien)===goc}
  function jdgm(){var st=document.querySelector("style.jdgm-settings-style");if(!st)return false;
    var t=st.textContent||"",v=function(ten){var m=new RegExp(ten+":\\s*([^;}]+)").exec(t);return m?m[1]:""};
    if(!/--jdgm-primary-color/.test(t))return false;
    if(khop(GOC.jdgm,v("--jdgm-primary-color"))&&khop(GOC.jdgm_sao,v("--jdgm-star-color"))&&khop(GOC.jdgm_nut,v("--jdgm-write-review-bg-color")))
      h.classList.add("tektron-jdgm");return true}
  function sticky(){var bar=document.querySelector(".Vtl-StickyAddToCart");if(!bar)return false;
    var nut=bar.querySelector(".Vtl-StickyAddToCart__AddToCartButton");
    if(khop(GOC.sticky,getComputedStyle(bar).backgroundColor)&&(!nut||khop(GOC.sticky_nut,getComputedStyle(nut).backgroundColor)))
      h.classList.add("tektron-sticky");return true}
  var da_j=jdgm(), da_s=sticky(), n=0;
  var t=setInterval(function(){if(!da_j)da_j=jdgm();if(!da_s)da_s=sticky();if((da_j&&da_s)||++n>120)clearInterval(t)},500);
})();
